module.exports = __webpack_public_path__ + "img/reload.89f5a048.svg";